<div [className]="'adyen-3ds-modal ' + challengeType">
  <div mm-dialog-title>
    <div class="adyen-3ds-modal__header">
      <mm-icon class="fluid adyen-3ds-modal__header__logo" name="metro-logo"></mm-icon>
      <mm-icon class="adyen-3ds-modal__header__close fluid" name="close" (click)="closeDialog(true)"></mm-icon>
      <div class="adyen-3ds-modal__content__spinner-wrapper" *ngIf="isAdyenLoading">
        <mm-spinner class="adyen-3ds-modal__content__spinner" size="50" strokeWidth="2"> </mm-spinner>
      </div>
    </div>
  </div>
  <div mm-dialog-content class="adyen-3ds-modal__content" test-target="adyen-3ds-modal__content">
    <div #adyenDropinContainer></div>
  </div>
</div>
